export default from './Slider';



// WEBPACK FOOTER //
// ./src/sharedComponents/Slider/index.js